import { render, staticRenderFns } from "./project-admin-quick-buttons.vue?vue&type=template&id=0aad9ae4"
import script from "./project-admin-quick-buttons.vue?vue&type=script&lang=js"
export * from "./project-admin-quick-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports